import { render, staticRenderFns } from "./ActivityDetailTable.vue?vue&type=template&id=ca1bc550&scoped=true&"
import script from "./ActivityDetailTable.vue?vue&type=script&lang=js&"
export * from "./ActivityDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDetailTable.vue?vue&type=style&index=0&id=ca1bc550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1bc550",
  null
  
)

export default component.exports